import { useGetControls } from "api/generated/controls/controls";

import { SchedulingTypeOrAll } from "../columns";

import { CONTROL_LIST_QUERY_OPTIONS } from "./controlListQueryOptions";

export function useControlListQuery(schedulingTypeOrAll: SchedulingTypeOrAll) {
    return useGetControls(
        schedulingTypeOrAll === "All"
            ? undefined
            : { scheduling_type: schedulingTypeOrAll },
        {
            query: {
                ...CONTROL_LIST_QUERY_OPTIONS,
                select: (response) => response.data,
            },
        }
    );
}
